import script from "./BasketLineItemModuleSofa.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasketLineItemModuleSofa.vue?vue&type=script&lang=ts&setup=true"

import "./BasketLineItemModuleSofa.vue?vue&type=style&index=0&id=6024455b&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6024455b"]])

export default __exports__